module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/2-981493e1b194085a3b4b30c021e8c287.png";